// Text block for the Live tab: seeding line from pool standings, and the
// team's playoff round progression (current round / advanced / eliminated /
// champion) once the team has playoff games in this tournament

import { GameTypes, roundIndex } from '../utils/enums';
import { sortGamesChrono, roundName } from '../utils/live';
import './LivePlayoffStatus.scss';

export default function LivePlayoffStatus({ tournament, teamId, division, pool }) {
  const myPoolRow = pool.rows.find((r) => r.teamId === teamId);

  // The team's playoff games in round order (chronological within a round).
  // Byes mean a team's list can start partway through the bracket (e.g. only
  // a Semifinal + Final entry) — using round order here instead of a
  // standings rank keeps status accurate for byed teams.
  const playoffGames = sortGamesChrono(
    tournament.games.filter(
      (g) =>
        g.type === GameTypes.PLAYOFF &&
        (g.team1 === teamId || g.team2 === teamId),
    ),
  ).sort((a, b) => roundIndex(a.round) - roundIndex(b.round));

  let seedLine = null;

  if (playoffGames.length === 0) {
    if (myPoolRow && myPoolRow.gamesPlayed > 0) {
      seedLine = pool.isComplete
        ? `Pool play complete — seed #${myPoolRow.rank} in ${division}`
        : `Current: #${myPoolRow.rank} (${myPoolRow.wins}-${myPoolRow.losses}-${myPoolRow.ties}) in ${division}`;
    }
  } else {
    const furthest = playoffGames[playoffGames.length - 1];
    const played = furthest.score1 != null && furthest.score2 != null;
    const round = roundName(furthest.round) || 'playoffs';

    if (!played) {
      seedLine = `Playoff: currently in ${round}`;
    } else {
      const my = furthest.team1 === teamId ? furthest.score1 : furthest.score2;
      const opp = furthest.team1 === teamId ? furthest.score2 : furthest.score1;

      if (my > opp) {
        seedLine =
          furthest.round === 'F'
            ? `Playoff complete — Champion of ${division}`
            : `Advanced from ${round} — next game will be assigned soon`;
      } else if (my < opp) {
        seedLine = `Playoff run ended in ${round}`;
      }
    }
  }

  if (!seedLine) return null;

  return (
    <div className='live-playoff-status'>
      <p className='seed'>{seedLine}</p>
    </div>
  );
}
